import { MARKER_LIFETIME_MS } from '@/business-logic/course-conversion-discovery'

const MAX_UNCLICKED_MENU_OPENINGS = 3

export { MARKER_LIFETIME_MS }

export const DISCOVERY_STATE_FIELD = 'customFontUploadDiscovery'
export const CUSTOM_FONT_UPLOAD_DISCOVERY_FLAG = 'AHA-49323-custom-font-upload-discovery'

export const readDiscoveryState = (personalInformation) => {
  const stored = personalInformation?.[DISCOVERY_STATE_FIELD]
  const state = stored && typeof stored === 'object' ? stored : {}
  return {
    eligibleAt: state.eligibleAt || null,
    firstSeenAt: state.firstSeenAt || null,
    unclickedViews: Number.isFinite(state.unclickedViews) ? state.unclickedViews : 0,
    menuOpenedAt: state.menuOpenedAt || null,
    discoveredAt: state.discoveredAt || null,
    usedAt: state.usedAt || null,
  }
}

const toTime = (value) => {
  const time = new Date(value).getTime()
  return Number.isNaN(time) ? null : time
}

const isMarkerLifetimeOver = (state, now = Date.now()) => {
  const firstSeenTime = state.firstSeenAt ? toTime(state.firstSeenAt) : null
  return firstSeenTime !== null && now - firstSeenTime >= MARKER_LIFETIME_MS
}

export const hasReachedUnclickedLimit = (state) => state.unclickedViews >= MAX_UNCLICKED_MENU_OPENINGS

export const shouldShowMarkers = (state, now = Date.now()) => {
  if (!state || state.discoveredAt || state.usedAt) return false
  if (hasReachedUnclickedLimit(state)) return false
  return !isMarkerLifetimeOver(state, now)
}

export const shouldShowDot = (state, now = Date.now()) => shouldShowMarkers(state, now) && !state.menuOpenedAt

const stampOnce = (state, key, now) => ({
  ...state,
  [key]: state[key] || new Date(now).toISOString(),
})

export const recordEligible = (state, now = Date.now()) => stampOnce(state, 'eligibleAt', now)

export const recordFirstSeen = (state, now = Date.now()) => stampOnce(state, 'firstSeenAt', now)

export const recordMenuOpened = (state, now = Date.now()) => ({
  ...stampOnce(state, 'menuOpenedAt', now),
  unclickedViews: state.unclickedViews + 1,
})

export const recordDiscovered = (state, now = Date.now()) => stampOnce(state, 'discoveredAt', now)

export const recordUsed = (state, now = Date.now()) => stampOnce(recordDiscovered(state, now), 'usedAt', now)
